import { Link, useLocation } from "react-router-dom";
import { useFreshNav } from "@/hooks/useFreshNav";
import { CalendarDays, Check, ChevronDown, Columns3, Shield } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const VIEWS = [
  { to: "/", label: "Players Projections", icon: Columns3, id: "nav-triple" },
  { to: "/team-projections", label: "Team Projections", icon: Shield, id: "nav-team-projections" },
  { to: "/today", label: "Game Center", icon: CalendarDays, id: "nav-today" },
];

// Split button: the current slate view (Triple View by default); the arrow opens the other view.
export function ViewSwitch() {
  const { pathname } = useLocation();
  const fresh = useFreshNav();
  const onSlate = VIEWS.some((v) => v.to === pathname);
  const current = VIEWS.find((v) => v.to === pathname) || VIEWS[0];
  const Icon = current.icon;
  const tone = onSlate ? "bg-blue-600 text-white shadow-[0_0_14px_rgba(37,99,235,0.45)]" : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/60";
  return (
    <div className={`flex items-center mr-1 rounded-md transition-colors ${tone}`} data-testid="nav-view-switch">
      <Link to={current.to} onClick={fresh(current.to)} data-testid={current.id} className="flex items-center gap-2 pl-3 pr-2 py-2 text-sm font-semibold whitespace-nowrap">
        <Icon className="h-4 w-4" /><span className="hidden sm:inline">{current.label}</span>
      </Link>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger data-testid="nav-view-menu" aria-label="Choose view"
          className={`self-stretch px-1.5 rounded-r-md border-l ${onSlate ? "border-white/25 hover:bg-blue-500" : "border-slate-700 hover:bg-slate-800"} outline-none`}>
          <ChevronDown className="h-4 w-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="min-w-[170px] bg-[#0B1424] border-slate-700 text-slate-200">
          {VIEWS.map(({ to, label, icon: ItemIcon, id }) => (
            <DropdownMenuItem key={to} asChild>
              <Link to={to} onClick={fresh(to)} data-testid={`${id}-option`} className="flex items-center gap-2 cursor-pointer">
                <ItemIcon className="h-4 w-4" />{label}
                {to === current.to && onSlate && <Check className="ml-auto h-4 w-4 text-blue-400" />}
              </Link>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
